import { render } from "./RecentDevices.vue?vue&type=template&id=1c1cf2d0"
import script from "./RecentDevices.vue?vue&type=script&lang=js"
export * from "./RecentDevices.vue?vue&type=script&lang=js"

import "./RecentDevices.vue?vue&type=style&index=0&id=1c1cf2d0&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__